module.exports = __webpack_public_path__ + "fonts/light.386f61c2.woff2";